/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const DownloadCloud = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" }],
    ["path", { d: "M12 12v9" }],
    ["path", { d: "m8 17 4 4 4-4" }]
  ]
];

export { DownloadCloud as default };
//# sourceMappingURL=download-cloud.js.map
